module.exports = __webpack_public_path__ + "media/audio18.7f240cd1.mp3";